/**
 * Selectie-gedrag voor de verf-PDP (afwerking + inhoud).
 *
 * Radio-opties blijven radio's: een her-klik op de al gekozen inhoud/afwerking
 * mag de keuze niet uitzetten. Dat zette `body.verf-incomplete` en daarmee de ATC
 * visueel op slot (ux-fixes.css).
 *
 * Wel: nette prijs-overgang. Zodra een nieuwe variant wordt gekozen haalt
 * variant-picker.js async de nieuwe prijs op. We houden de prijs verborgen zolang
 * een fetch loopt (`variant:selected` → `variant:update`).
 *
 * Body-classes (CSS in ux-fixes.css reageert hierop):
 *   .verf-incomplete    — geen afwerking óf geen inhoud gekozen → prijs weg + cart op slot
 *   .verf-price-pending — variant-fetch loopt → prijs even verborgen (cart blijft actief)
 */
(function () {
  if (window.__afwSelectionInit) return;
  window.__afwSelectionInit = true;

  var AFW_SEL = '.variant-option--afwerking-cards';
  var INHOUD_SEL = '.variant-picker .variant-option[data-option-name="Inhoud"]';
  var LABEL_SEL = '.variant-option__button-label';

  function afwFieldset() { return document.querySelector(AFW_SEL); }
  function inhoudFieldset() { return document.querySelector(INHOUD_SEL); }
  function hasChecked(fs) { return !!(fs && fs.querySelector('input[type="radio"]:checked')); }
  function isVerfPdp() { return !!afwFieldset(); }

  // --- Selectie-staat: bepaalt of de prijs/cart vrijgegeven mogen worden ---
  function updateState() {
    if (!isVerfPdp()) return;
    var inh = inhoudFieldset();
    var complete = hasChecked(afwFieldset()) && (!inh || hasChecked(inh));
    document.body.classList.toggle('verf-incomplete', !complete);
  }

  // --- Prijs-pending: tel lopende variant-fetches; prijs verborgen zolang > 0 ---
  var pendingCount = 0;
  var pendingWatchdog = null;
  var userEngaged = false; // negeer de auto-selectie tijdens initial load

  function armWatchdog() {
    if (pendingWatchdog) clearTimeout(pendingWatchdog);
    pendingWatchdog = setTimeout(function () {
      pendingCount = 0;
      document.body.classList.remove('verf-price-pending');
      pendingWatchdog = null;
    }, 1500);
  }
  function pendingInc() {
    if (!userEngaged || !isVerfPdp()) return;
    pendingCount++;
    document.body.classList.add('verf-price-pending');
    armWatchdog();
  }
  function pendingDec() {
    if (pendingCount > 0) pendingCount--;
    if (pendingCount === 0) {
      document.body.classList.remove('verf-price-pending');
      if (pendingWatchdog) { clearTimeout(pendingWatchdog); pendingWatchdog = null; }
    }
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && (e.target.closest('.variant-picker') || e.target.closest('paint-application-filter'))) {
      userEngaged = true;
    }
  }, true);

  // --- Lange afwerking-lijst inklappen: toon de eerste 3, rest achter "Bekijk alle …" ---
  // Werkt op de feitelijk zichtbare kaarten (na ruimte-/applicatie-filter), niet blind op
  // nth-child. De geselecteerde afwerking mag nooit in de verborgen staart vallen.
  var COLLAPSE_VISIBLE = 3;     // standaard zichtbaar
  var COLLAPSE_THRESHOLD = 5;   // pas inklappen vanaf zoveel zichtbare afwerkingen
  var OVERFLOW_CLS = 'afw-collapsed-overflow';
  var FILTER_HIDE_CLS = ['variant-option--hidden-by-liquid', 'variant-option--filtered-out', 'afw-ruimte-hidden'];
  var OBSERVE_OPTS = { subtree: true, attributes: true, attributeFilter: ['class'] };
  var collapseObserver = null;

  function isFilterHidden(label) {
    for (var i = 0; i < FILTER_HIDE_CLS.length; i++) {
      if (label.classList.contains(FILTER_HIDE_CLS[i])) return true;
    }
    return false;
  }

  function ensureToggleBtn(fs) {
    var btn = fs.querySelector('[data-afw-toggle]');
    if (btn) return btn;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'afw-show-all';
    btn.hidden = true;
    btn.setAttribute('data-afw-toggle', '');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML =
      '<span class="afw-show-all__text"></span>' +
      '<svg class="afw-show-all__chevron" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
      '<path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var fieldset = afwFieldset();
      if (!fieldset) return;
      // 'afw-user-expanded' = expliciete gebruikerswens (plakkend); het vangnet voor de
      // geselecteerde-in-de-staart wordt elke run opnieuw afgeleid, niet hier opgeslagen.
      fieldset.classList.toggle('afw-user-expanded');
      applyCollapse();
    });
    fs.appendChild(btn);
    return btn;
  }

  // Tijdens onze eigen class-mutaties luistert de observer niet mee (disconnect →
  // muteren → reconnect), zodat we geen recompute-loop op onszelf veroorzaken.
  function applyCollapse() {
    var fs = afwFieldset();
    if (!fs) return;
    if (collapseObserver) collapseObserver.disconnect();

    var labels = [].slice.call(fs.querySelectorAll(LABEL_SEL));
    var visible = labels.filter(function (l) { return !isFilterHidden(l); });
    labels.forEach(function (l) { l.classList.remove(OVERFLOW_CLS); });

    var btn = ensureToggleBtn(fs);

    if (visible.length < COLLAPSE_THRESHOLD) {
      fs.classList.remove('afw-collapsible', 'afw-expanded');
      btn.hidden = true;
    } else {
      fs.classList.add('afw-collapsible');
      var overflow = visible.slice(COLLAPSE_VISIBLE);

      // Vangnet (elke run opnieuw afgeleid, niet plakkend): zit de geselecteerde
      // afwerking in de verborgen staart, dan moet de lijst open — anders zou de
      // actieve keuze onzichtbaar zijn.
      var checkedInTail = overflow.some(function (l) {
        var input = l.querySelector('input[type="radio"]');
        return input && input.checked;
      });
      var expanded = fs.classList.contains('afw-user-expanded') || checkedInTail;
      fs.classList.toggle('afw-expanded', expanded);

      if (!expanded) {
        overflow.forEach(function (l) { l.classList.add(OVERFLOW_CLS); });
      }

      var txt = btn.querySelector('.afw-show-all__text');
      if (txt) {
        txt.textContent = expanded ? 'Toon minder' : 'Bekijk alle ' + visible.length + ' afwerkingen';
      }
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.hidden = false;
    }

    if (collapseObserver) collapseObserver.observe(fs, OBSERVE_OPTS);
  }

  function scheduleCollapse() { setTimeout(applyCollapse, 0); }

  function observeCollapse() {
    var fs = afwFieldset();
    if (!fs || collapseObserver) return;
    // Andere scripts (applicatie-filter, ruimte-count) togglen visibility-classes;
    // elke class-wijziging op een kaart triggert een herberekening.
    collapseObserver = new MutationObserver(applyCollapse);
    collapseObserver.observe(fs, OBSERVE_OPTS);
  }

  // --- Events ---
  document.addEventListener('variant:selected', pendingInc);
  document.addEventListener('variant:update', function () { pendingDec(); updateState(); scheduleCollapse(); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.variant-picker')) { updateState(); scheduleCollapse(); }
  });
  document.addEventListener('paint-filter:changed', function () { setTimeout(updateState, 0); scheduleCollapse(); });
  document.addEventListener('paint-filter:cleared', function () { setTimeout(updateState, 0); scheduleCollapse(); });

  function init() { updateState(); applyCollapse(); observeCollapse(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
